// Split strategy constants
export const CENTER = 0;
export const AVERAGE = 1;
export const SAH = 2;
